import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=10c41ad7"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=10c41ad7&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c41ad7')) {
      api.createRecord('10c41ad7', component.options)
    } else {
      api.reload('10c41ad7', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=10c41ad7", function () {
      api.rerender('10c41ad7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/purchase/views/Main.vue"
export default component.exports